import React from 'react';
import { useStyles } from 'components/Statistics/styles';

import { CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';

import _ from 'lodash';
import { CHART_COLORS, CHART_HEIGHT, CHART_WIDTH } from './Statistics';
import { formatNumberWithComma, formatTooltipLabel } from './utils';

type StreamingProps = {
  statisticsStreamingData: LineChartData[];
};

function Streaming({ statisticsStreamingData }: StreamingProps) {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <div className={classes.sectionTitleBox}>
        <div className={classes.sectionTitle}>스트리밍</div>
      </div>

      <div className={classes.sectionBody}>
        <LineChart
          width={CHART_WIDTH}
          height={CHART_HEIGHT}
          data={statisticsStreamingData}
          margin={{ top: 30, bottom: 5, left: 25, right: 25 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis label={{ value: '횟수', position: 'top', offset: 15 }} width={20} />
          <Tooltip
            labelFormatter={value => {
              return [formatTooltipLabel(value)];
            }}
            formatter={value => {
              return [`${formatNumberWithComma(value)}회`, '총 스트리밍'];
            }}
          />
          <Line dataKey="value" stroke={CHART_COLORS.default} isAnimationActive={false} />
        </LineChart>
      </div>
    </div>
  );
}

export default Streaming;
